"use strict";

var _regeneratorRuntime = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var cryptoUtils_1 = require("./cryptoUtils");

var NodeCryptoHmacSha256 =
/*#__PURE__*/
function () {
  function NodeCryptoHmacSha256(createHmac) {
    _classCallCheck(this, NodeCryptoHmacSha256);

    this.createHmac = createHmac;
  }

  _createClass(NodeCryptoHmacSha256, [{
    key: "digest",
    value: function digest(key, data) {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = this.createHmac('sha256', key).update(data).digest();
                return _context.abrupt("return", Promise.resolve(result));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return NodeCryptoHmacSha256;
}();

exports.NodeCryptoHmacSha256 = NodeCryptoHmacSha256;

var WebCryptoHmacSha256 =
/*#__PURE__*/
function () {
  function WebCryptoHmacSha256(subtleCrypto) {
    _classCallCheck(this, WebCryptoHmacSha256);

    this.subtleCrypto = subtleCrypto;
  }

  _createClass(WebCryptoHmacSha256, [{
    key: "digest",
    value: function digest(key, data) {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var cryptoKey, sig;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.subtleCrypto.importKey('raw', key, {
                  name: 'HMAC',
                  hash: 'SHA-256'
                }, true, ['sign']);

              case 2:
                cryptoKey = _context2.sent;
                _context2.next = 5;
                return this.subtleCrypto.sign( // The `hash` is only specified for non-compliant browsers like Edge. 
                {
                  name: 'HMAC',
                  hash: 'SHA-256'
                }, cryptoKey, data);

              case 5:
                sig = _context2.sent;
                return _context2.abrupt("return", Buffer.from(sig));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return WebCryptoHmacSha256;
}();

exports.WebCryptoHmacSha256 = WebCryptoHmacSha256;

function createHmacSha256() {
  return tslib_1.__awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var cryptoLib;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return cryptoUtils_1.getCryptoLib();

          case 2:
            cryptoLib = _context3.sent;

            if (!(cryptoLib.name === 'subtleCrypto')) {
              _context3.next = 7;
              break;
            }

            return _context3.abrupt("return", new WebCryptoHmacSha256(cryptoLib.lib));

          case 7:
            return _context3.abrupt("return", new NodeCryptoHmacSha256(cryptoLib.lib.createHmac));

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

exports.createHmacSha256 = createHmacSha256;